import React, { useEffect, useState } from "react";
import { getJiraWorklogs } from "../../../utils/getJiraIssueApi"
import { getTotalNonServiceTime, formatTime } from "../../../utils/timeCalculations";
import {
  Container,
  InfoText,
  ProgressBarWrapper,
  ProgressBar,
  ProgressText,
  OverLimitIndicator,
  ProgressBarBackground,
  InactiveProgressBar,
} from "./styled";

export const SummaryWorklogs = () => {
  const [notLoggedIn, setNotLoggedIn] = useState(false);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("access_token");

    if (!token) {
      setNotLoggedIn(true);
      setLoading(false);
      return;
    }

    const today = new Date();
    const startDate = new Date(Date.UTC(today.getFullYear(), today.getMonth(), 1));
    const endDate = new Date(Date.UTC(today.getFullYear(), today.getMonth() + 1, 0));

    const fetchData = async () => {
      try {
        const response = await getJiraWorklogs(
          startDate.toISOString().split("T")[0],
          endDate.toISOString().split("T")[0]
        );
        setData(response || {});;
      } catch (err) {
        console.error("Błąd podczas pobierania danych:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (notLoggedIn) {
    return (
      <Container>
        <InfoText>Dane dot. czasu serwisowego są widoczne dla zalogowanych użytkowników</InfoText>
        <ProgressBarWrapper>
          <InactiveProgressBar>
            <ProgressText>
              Zużycie: 00h 00m / 00h 00m &nbsp; | &nbsp;Limit miesięczny: 00h 00m &nbsp; | &nbsp;Przeniesione: 00h 00m &nbsp; | &nbsp;Nieserwisowe: 00h 00m
            </ProgressText>
          </InactiveProgressBar>
        </ProgressBarWrapper>
      </Container>
    );
  }

  if (loading || !data) return null;

  const today = new Date();
  const serviceTimeLimitH = data?.result.apiUsageInfoDto?.serviceTimeLimit || 0;
  const timeSavedInPreviousMonth = data?.result.worklogSummary?.timeSavedInPreviousMonth || 0;
  const sumTimeInSec = data?.result.worklogSummary?.sumTimeInSecound || 0;

  const totalUsedMinutes = Math.floor(sumTimeInSec / 60);
  const carriedMinutes = Math.floor(timeSavedInPreviousMonth / 60);
  const limitMinutes = serviceTimeLimitH * 60;
  const totalAvailable = limitMinutes + carriedMinutes;

  const overLimit = totalUsedMinutes > totalAvailable;
  const progressPercent = totalAvailable > 0
    ? Math.min((totalUsedMinutes / totalAvailable) * 100, 100)
    : 0;

  const totalNonServiceTime = getTotalNonServiceTime(data, today.getMonth(), today.getFullYear());

  return (
    <Container>
      <InfoText>
        Zużycie: <b>{formatTime(totalUsedMinutes * 60)} / {formatTime(totalAvailable * 60)}</b>
        &nbsp;Czas nieserwisowy: <b>{formatTime(totalNonServiceTime)}</b>
        <br/>
        Limit miesięczny: <b>{formatTime(limitMinutes * 60)}</b>
        &nbsp;Przeniesione: <b>{formatTime(carriedMinutes * 60)}</b>
      </InfoText>

      <ProgressBarWrapper>
        <ProgressBar style={{ width: `${progressPercent}%` }}>
          <ProgressText>{formatTime(totalUsedMinutes * 60)}</ProgressText>
        </ProgressBar>

        {!overLimit && (
          <ProgressBarBackground style={{ width: `${100 - progressPercent}%` }}>
            <ProgressText>{formatTime((totalAvailable - totalUsedMinutes) * 60)}</ProgressText>
          </ProgressBarBackground>
        )}

        {overLimit && (
          <OverLimitIndicator>
            +{formatTime((totalUsedMinutes - totalAvailable) * 60)}
          </OverLimitIndicator>
        )}
      </ProgressBarWrapper>
    </Container>
  );
};
